/* eslint-disable */
import {
  GET_SUB_CATEGORY,
  GET_SUB_CATEGORY_SUCCESS,
  GET_SUB_CATEGORY_ERROR,
} from './../actionTypes';

const defaultState = {
  loading: null,
  error: {},
  data: {},
};

export default function (state = defaultState, action) {
  switch (action.type) {

    case GET_SUB_CATEGORY:
      return Object.assign({}, state, {
        loading: true,
        error: {},
      })

    case GET_SUB_CATEGORY_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data || {},
      })

    case GET_SUB_CATEGORY_ERROR:
      return Object.assign({}, state, {
        loading: false,
        error: action.error,
      })

    default:
      return state;
  }
}
